import { API_URI } from "../environment";
import { TOKEN_KEY } from "./key.const";

export const API = {
  GET_APPOINTMENTS: API_URI + "/api/consulations/appoinment/",
  POST_APPOINTMENT: API_URI + "/api/consulations/appoinment/",

  GET_RECORDINGS: API_URI + "/api/consulations/recording/",
  GET_RECORDINGS_FILE: (id) =>
    API_URI + `/api/consulations/recording-file/${id}/`,
  POST_RECORDING: API_URI + "/api/consulations/recording/",
  UPDATE_RECORDING: API_URI + "/api/consulations/recording/",

  GET_PROFILE: API_URI + "/api/auth/",
  UPDATE_PROFILE: API_URI + "/api/auth/",

  MICROSOFT_HANDLE_LOGIN: API_URI + "/api/auth/microsoft_handle_login/",
  MICROSOFT_LOGIN: API_URI + "/api/auth/microsoft_login/",

  //auth
  LOGIN: API_URI + "/api/auth/login/",
  RESEND_OTP: API_URI + "/api/auth/resend-otp/",
  SIGNUP: API_URI + "/api/auth/signup/",
  VERIFY_EMAIL: API_URI + "/api/auth/email-verify/",

  //forgot password
  EMAIL_CHECK: API_URI + "/api/auth/check-email/",
  VERIFY_OTP: API_URI + "/api/auth/verify-opt/",
  RESET_PASSWORD: API_URI + "/api/auth/reset-password/",

  //change password
  CHANGE_PASSWORD: API_URI + "/api/auth/change-password/",

  //get all users
  GET_ALL_USERS: API_URI + "/api/auth/users/",

  //sign up admin user
  SIGNUP_ADMIN: API_URI + "/api/auth/signup-by-admin/",

  //appointment
  APPOINTMENT_ADMIN: API_URI + "/api/consulations/appoinment-admin/",

  // Solevania
  START_RECORDING: API_URI + "/api/consulations/start-recording/",
  SUBMIT_RECORDING: API_URI + "/api/consulations/submit-recording/",
  SUMMARY_VIEW: API_URI + "/api/consulations/recording-summary/",
  GET_DIAGNOSZAS: API_URI + "/api/consulations/diagnoza/",
  GET_SIFRE_STORITVE: API_URI + "/api/consulations/sifre-storitve/",
  ADD_NEW_SIFRE_CODE: API_URI + "/api/consulations/recording-add-sifra/",
  ADD_DIAGNOSZA_CODE: API_URI + "/api/consulations/recording-add-diagnoza/",
  RECORDING_STATUS: API_URI + "/api/consulations/recording-status/",
  EDIT_RECORDING_SUMMARY: API_URI + "/api/consulations/recording-edit-summary/",
};
export const SetAUTH_HEADER = () => {
  AUTH_HEADER = {
    headers: { Authorization: "Bearer " + sessionStorage.getItem(TOKEN_KEY) },
  };
};

export var AUTH_HEADER = {
  headers: { Authorization: "Bearer " + sessionStorage.getItem(TOKEN_KEY) },
};

export const getAuthHeader = () => {
  return { Authorization: "Bearer " + sessionStorage.getItem(TOKEN_KEY) };
};
// export var AUTH_HEADER =  {headers : {Authorization : 'Bearer ' + adminStaticToken }}
